import { selectOptions } from 'constants'
import React from 'react'
import * as Yup from 'yup'

import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'

import { formatPhoneNumber, toSlug } from 'utils/string'

export type MyFormValues = {
  firstName?: string
  lastName?: string
  username?: string
  address?: string
  city?: string
  state?: string
  zipcode?: string
  phone?: string
  bio?: string
}

type Props = {
  onSubmit: (e: any) => void
  simpleView?: boolean
  initialValues?: MyFormValues
  submitCopy?: string
}

export const EditProfileForm = ({
  simpleView = false,
  initialValues = {
    firstName: '',
    lastName: '',
    username: '',
    address: '',
    city: '',
    state: '',
    zipcode: '',
    phone: '',
    bio: '',
  },
  onSubmit = () => null,
  submitCopy = 'Apply changes',
}: Props) => {
  const userSchema = Yup.object().shape({
    firstName: Yup.string().required('This field is required.'),
    lastName: Yup.string().required('This field is required.'),
    city: Yup.string(),
    state: Yup.string(),
    username: Yup.string().required('This field is required.'),
    address: Yup.string(),
    zipcode: Yup.string(),
    phone: simpleView
      ? Yup.string()
      : Yup.string()
          .matches(/^[0-9]+$/, 'Must be only digits')
          .min(10, 'Must be exactly 10 digits')
          .max(10, 'Must be exactly 10 digits'),
    bio: Yup.string(),
  })

  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      submitCopy={submitCopy}
      validationSchema={userSchema}
    >
      {({ errors: formikErrors, touched }: any) => (
        <>
          <Field required name='firstName' placeholder='Enter first name' label='First name' />
          <Field required name='lastName' placeholder='Enter last name' label='Last name' />
          <Field
            required
            icon='at-sign'
            name='username'
            editable={!initialValues.username}
            placeholder='Enter a username'
            format={(value: string) => toSlug(value, { trim: false, strict: false })}
            disabled={!!initialValues.username}
            label='Username'
          />
          <Field name='bio' placeholder='Enter a short bio' label='Bio' type='textarea' />
          <Field
            name='phone'
            hidden={simpleView}
            placeholder='Enter phone number'
            label='Phone number'
            keyboardType='phone-pad'
            format={(value: string) => formatPhoneNumber(value)}
          />
          <Field name='address' hidden={simpleView} placeholder='Enter address' label='Address' />
          <Field name='city' placeholder='Enter city' label='City' />
          <Field
            name='state'
            placeholder='Select state'
            label='State'
            type='select'
            options={selectOptions.STATE_OPTIONS}
          />
          <Field name='zipcode' hidden={simpleView} placeholder='Enter zipcode' label='Zip code' />
        </>
      )}
    </Form>
  )
}
